<template>
  <div @click.stop class="week-dialog">
    <el-dialog placement="bottom-start" visible @close="onClose" width="330px">
      <span slot="title" class="dialog-header">
        请选择需要导出的周
      </span>
      <div class="week">
        <div class="header" style="text-align:center;padding:0">
          <div>
            <button type="button" style="padding: 10px; margin: 0" aria-label="前一年" @click="onPrevY" class="el-picker-panel__icon-btn el-date-picker__prev-btn el-icon-d-arrow-left"></button>
            <button type="button" style="padding: 10px; margin: 0" aria-label="前一月" @click="onPrevM" class="el-picker-panel__icon-btn el-date-picker__prev-btn el-icon-arrow-left"></button>
          </div>
          <span>{{`${curY} 年 ${curM} 月`}}</span>
          <div>
            <button type="button" style="padding: 10px; margin: 0" aria-label="后一年" @click="onNextY" class="el-picker-panel__icon-btn el-date-picker__next-btn el-icon-d-arrow-right"></button>
            <button type="button" style="padding: 10px; margin: 0" aria-label="后一月" @click="onNextM" class="el-picker-panel__icon-btn el-date-picker__next-btn el-icon-arrow-right"></button>
          </div>
        </div>
        <div class="week-list" style="padding-bottom: 10px;">
          <div class="week-item" :style="curYMWeek.length > 4 ? 'width: 33.3%;':'width: 50%;'" v-for="(week, index) in curYMWeek" :key="index">
            <el-button :disabled="week.disabled" :type="week.selected ? 'primary' :''" @click.stop="onSelectWeek(week)">第 {{week.week}} 周</el-button>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" style="width: 100%; margin-top: 10px;" @click="onOK">导 出</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import weekMixin from './weekMixin'
import http from "api/freight";

export default {
  name: 'week-dialog',
  data() {
    return {
      curSelectedWeek: null,
    }
  },
  mixins: [weekMixin],
  computed: {
    selectedWeeks() {
      let tmpWeeks = []
      for (let year in this.hasWeekOfYear) {
        for (let month in this.hasWeekOfYear[year]) {
          for (let week of this.hasWeekOfYear[year][month]) {
            if (week.selected) {
              tmpWeeks.push(week)
            }
          }
        }
      }
      return tmpWeeks
    },
  },
  mounted() {
    this.getLatestWeek()
  },
  methods: {
    getLatestWeek() {
      http
          .latest_week({
            dimension: this.tabNum == 2 ? '1' : '',
            roadType: this.roadType
          })
          .then((e) => {
            let tmpData = e.data
            if (this.$route.query.year) {
              this.curSelectedWeek = {
                year: this.$route.query.year,
                month: this.$route.query.month,
                week: this.$route.query.week
              }
              this.$emit('on-command', {type: 'default-week'})
            } else {
              if (tmpData) {
                this.curSelectedWeek = tmpData
                this.$emit('on-command', {type: 'default-week'})
              }
            }
            this.getWeek(this.curSelectedWeek.year,this.curSelectedWeek)
          })
          .catch((err) => {
            console.error(err)
          })
    },
    onSelectWeek(week) {
      if (this.selectedWeeks.length >= 5 && !week.selected) {
        this.$message({
          message: '最多只能选择5个周！',
          type: 'warning',
        })
        return
      }
      week.selected = !week.selected
    },

    onOK() {
      if (!this.selectedWeeks.length) {
        this.$message({
          message: '请至少选择1个周！',
          type: 'warning',
        })
        return
      }

      this.$emit('on-command', {
        type: 'ok',
        data: {
          yearMonthWeeks: this.selectedWeeks
            .map((_) => `${_.year}-${_.month}-${_.week}`)
            .join(','),
        },
      })
    },

    onClose() {
      this.$emit('on-command', { type: 'close' })
    },
  },
}
</script>

<style lang="stylus" scoped>
@import './week.styl';

.dialog-header {
  font-size: 15px;
  font-weight: 600;
  padding-bottom: 10px;
}

.week-dialog /deep/ .el-dialog__body {
  padding: 0 10px;
}
</style>
